import React from 'react';
import PropTypes from 'prop-types';

import {
  REWARD_TYPES,
  REWARD_TYPE_LABEL,
} from '../../../../constants/achievements';
import { enumToString } from '../../../../util/text';

const propTypes = {
  reward: PropTypes.shape({
    id: PropTypes.string,
    type: PropTypes.string,
    amount: PropTypes.string,
  }),
};

const Reward = ({ reward }) => {
  return (
    <div className="achievement-unlocked-reward">
      <span className="reward-amount">
        +{reward.amount}
        {reward.type === REWARD_TYPES.PHOTO_STORAGE && 'GB'}
      </span>
      <span className="reward-label">
        {REWARD_TYPE_LABEL[reward.type] || enumToString(reward.type)}
      </span>
    </div>
  );
};

Reward.propTypes = propTypes;

export default Reward;
